import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import PanelCard from '../../performance-operations/components/PanelCard';
import { Table } from '../../performance-operations/styles';
import { usePanel } from '../../performance-operations/config';
import { Hidden, Note } from '../../../components/performance/evaluation/EvaluationParts';
import { formatNum, isSuppressed, metaOfContext } from '../../../components/performance/evaluation/evaluationAnalytics';
import { NS, fetchAnonymousGroups } from '../config';

// E06 — anonim grup detayları AYRI panel (analiz §9). Yalnız toplu sayılar: atanan/tamamlanan yanıt, yanıt oranı, grubun a
// eşiğini geçtiği ve altında kaldığı kişi sayısı, eşiği geçenlerin ortalaması (kişi sayısı k altındaysa gizli). Yanıtlayan adı,
// tekil puan, yanıt zamanı ve bireysel listeye geçiş YOKTUR — İK dahil; dışa aktarım da aynı kuralı uygular.
export default function AnonymousGroupsPanel({ filters, screen, onMeta }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const key = JSON.stringify([filters, screen]);
  const panel = usePanel(() => fetchAnonymousGroups(filters, screen), [key], !!filters.periodId);
  useEffect(() => { if (panel.data) onMeta?.('anonymousGroups', metaOfContext(panel.data)); }, [panel.data, onMeta]);
  const groups = panel.data?.groups || [];
  const a = panel.data?.context?.anonymityThreshold ?? 3;
  const empty = groups.every((g) => !g.assigned);

  return (
    <PanelCard
      panelKey="anonymousGroups" title={t(`${NS}.panel.anonymousGroups`)} span={5}
      loading={panel.loading} error={panel.error} onRetry={panel.retry} empty={groups.length === 0 || empty}
      emptyText={t(`${NS}.anonymous.empty`)}
    >
      <Note data-note="anonymity">{t(`${NS}.anonymous.rule`, { a })}</Note>
      <Table>
        <thead>
          <tr>
            <th>{t(`${NS}.col.group`)}</th>
            <th>{t(`${NS}.anonymous.responses`)}</th>
            <th>{t(`${NS}.anonymous.rate`)}</th>
            <th>{t(`${NS}.anonymous.shown`)}</th>
            <th>{t(`${NS}.anonymous.suppressed`)}</th>
            <th>{t(`${NS}.anonymous.average`)}</th>
          </tr>
        </thead>
        <tbody>
          {groups.map((g) => (
            <tr key={g.group} data-row={g.group}>
              <td>{t(`${NS}.raterGroup.${g.group}`)}</td>
              <td>{`${formatNum(g.completed, lang, 0)} / ${formatNum(g.assigned, lang, 0)}`}</td>
              <td>{g.responseRate === null || g.responseRate === undefined ? '-' : `${formatNum(g.responseRate, lang)}%`}</td>
              <td>{formatNum(g.personsShown, lang, 0)}</td>
              <td>{formatNum(g.personsSuppressed, lang, 0)}</td>
              <td>
                {isSuppressed(g) ? <Hidden ns={NS} />
                  : (g.average === null || g.average === undefined ? '-' : formatNum(g.average, lang))}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </PanelCard>
  );
}
